import { useQuery } from '@tanstack/react-query';
import { useMe } from '../../../organisation/useMe';
import { personSegmentResultsApi, segmentsApi, transactionSegmentResultsApi } from '../../../apis';
import { InternalApiEntityType, InternalApiSegmentFullCalculationState } from '../../../api-internal';
import reFetchingHelper from '../../../common/reFetchingHelper';

interface QuerySegmentResultsProps {
  code: string;
  limit?: number;
  fullCalculationState?: InternalApiSegmentFullCalculationState;
}
export const useQuerySegmentResults = ({ code, limit = 5, fullCalculationState }: QuerySegmentResultsProps) => {
  const { currentOrganisation } = useMe();

  return useQuery({
    enabled: !!currentOrganisation?.id,
    queryKey: ['segmentResults', code, currentOrganisation?.id],
    staleTime: 1_000,
    refetchInterval: (query) => {
      const segmentResults = query.state.data;
      return fullCalculationState !== 'STARTED' || (!!segmentResults && segmentResults.length >= limit)
        ? false
        : reFetchingHelper.getSegmentResultsReFetchInterval();
    },
    queryFn: () => segmentsApi.findSegmentResults({ code, limit }),
  });
};

export const useQueryEntitySegmentResults = (entityId: string, entityType: InternalApiEntityType) => {
  const { currentOrganisation } = useMe();

  return useQuery({
    enabled: !!entityId,
    queryKey: ['segmentResults', entityId, entityType, currentOrganisation?.id],
    staleTime: 1_000,
    queryFn: () =>
      entityType === InternalApiEntityType.PERSON
        ? personSegmentResultsApi.findPersonSegmentResults({ personId: entityId })
        : transactionSegmentResultsApi.findTransactionSegmentResults({ transactionId: entityId }),
  });
};
